export default __webpack_public_path__ + "static/media/scrate.516a9eec.png";